import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=7c66396c&lang=scss"

const __exports__ = script;

export default __exports__